export default class VotingPrecinctChoroplethStyleConfig {
    constructor(){
        this.config = {
            votingPrecincts: {
                title: "<span class='text-h6'>Overlay: 2020 presidential election vote share</span><br />",
                titleplaintext: "Overlay: 2020 vote share",
                description: "2020 presidential election data <a href='https://www.nytimes.com/interactive/2021/upshot/2020-election-map.html' target='_blank'>from the New York Times</a> (Blank areas on the map = data not available)",
                scale:[], //Unlike other choropleth layers, this isn't added via data join so there's nothing here. It's set in ChoroplethLayerConfig.js
                getLegendValues: function(scale){

                    return [
                        {
                            color: "#b2182b",
                            label: 'Trump vote share 80% or more'
                        },
                        {
                            color: "#ef8a62",
                            label: 'Trump vote share 60%-80%'
                        },
                        {
                            color: "#fddbc7",
                            label: 'Trump vote share 50%-60%'
                        },
                        {
                            color: "#d1e5f0",
                            label: 'Biden vote share 50%-60%'
                        },
                        {
                            color: "#67a9cf",
                            label: 'Biden vote share 60%-80%'
                        },
                        {
                            color: "#2166ac",
                            label: 'Biden vote share 80% or more'
                        }
                    ]
                }
            },
            
        }
    }
}